<rotec-tile-v2
  [image]="machine.pictureId | rotecImageV2 | async"
  [class.task-overdue]="machine.kpi?.numberTasksOverdue"
  [borderForMain]="machine.kpi && machine.kpi.numberTasksOverdue > 0"
  (tileClick)="openDetails()"
>
  <ng-container ngProjectAs="tile-v2-title" class="title">
    <div class="names">
      <span class="machine-name" [title]="machine.name"
        ><span translate>Machine</span>: {{ machine.name }}</span
      >
    </div>
    <div class="tile-menu">
      @if (machine.documentIds.length > 0) {
        <rotec-icon-v2 svgIcon="attachment" (click)="showDocuments()"></rotec-icon-v2>
      }
    </div>
  </ng-container>
  <ng-container ngProjectAs="tile-v2-content">
    <div class="tile-block">
      <p class="block-title" translate>Task Overview</p>
      <p class="block-text" translate>Next Year (365 Days)</p>
    </div>
    <div class="tile-block">
      <p class="block-title" translate>Plant</p>
      <div class="block-content" [title]="state.plant?.name">{{ state.plant?.name }}</div>
    </div>
    <div class="tile-block">
      <p class="block-title tasks" translate>Tasks</p>
      <div class="block-content task">
        <p translate class="task__name">Planned</p>
        <div class="task__value">{{ machine.kpi?.numberActiveTasks }}</div>
      </div>
      <div class="block-content task">
        <p translate class="task__name">High Priority</p>
        <div class="task__value">{{ machine.kpi?.numberTasksHighPriority }}</div>
      </div>
      <div class="block-content task">
        <p translate class="task__name" [class.overdue]="!!machine.kpi?.numberTasksOverdue">
          Overdue
        </p>
        <div class="task__value" [class.overdue]="!!machine.kpi?.numberTasksOverdue">
          {{ machine.kpi?.numberTasksOverdue }}
        </div>
      </div>
    </div>
    <div class="control-area">
      <button
        rotec-button-active
        icon="tasks"
        class="control-button"
        (click)="showTasks()"
      ></button>
    </div>
  </ng-container>
</rotec-tile-v2>
